module.exports = __webpack_public_path__ + "img/cjqt.789f57cc.png";